export const ImageResizer = (src, width, height, smart) => {
  const service = 'https://resize.hawaii.do'

  let transform = []
  transform.push([width ? width : '', height ? height : ''].join('x'))
  if (smart) transform.push('sc')

  return [service, transform.join(','), encodeURI(src)].join('/')
}
